import { ScopedRole__SolutionScope } from "model/schema/globalTypes";
import { useReducer } from "react";
import { QueryPossibleMembers_solutions_Solutions_solution_Solution_access_SolutionAccessViewModel_possibleMembers_User as User } from "../schema/QueryPossibleMembers";

export interface State {
  user: User | null;
  roles: ScopedRole__SolutionScope[];
}

export type Action =
  | { type: "SET_USER"; value: User | null }
  | { type: "UPDATE_ROLES"; value: ScopedRole__SolutionScope[] }
  | { type: "RESET" };

export default function useInviteSolutionMemberReducer(initialState: State) {
  function reducer(state: State, action: Action): State {
    switch (action.type) {
      case "SET_USER":
        return { ...state, user: action.value };
      case "UPDATE_ROLES":
        return { ...state, roles: action.value };

      case "RESET":
        return { ...initialState };
      default:
        throw new Error();
    }
  }

  return useReducer(reducer, initialState);
}
